import { create } from 'zustand';
import type { Phase4Store } from '../types/internal';

export const usePhase4Store = create<Phase4Store>()((set) => ({
  tdBattleResult: null,

  recordTDBattle: (result) => set({ tdBattleResult: result }),

  reset: () => set({ tdBattleResult: null }),
}));
